/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsFabricTypeListItem,
    DigitizingserviceMelcoDigitizingModelsFabricTypeListItemFromJSON,
    DigitizingserviceMelcoDigitizingModelsFabricTypeListItemFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsFabricTypeListItemToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem
 */
export interface DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem {
    /**
     * 
     * @type {Array<DigitizingserviceMelcoDigitizingModelsFabricTypeListItem>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem
     */
    list: Array<DigitizingserviceMelcoDigitizingModelsFabricTypeListItem>;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem
     */
    total: number;
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemFromJSON(json: any): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem {
    return DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingserviceMelcoDigitizingModelsFabricTypeListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItemToJSON(value?: DigitizingserviceMelcoModelsGenericList1MelcoDigitizingModelsFabricTypeListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingserviceMelcoDigitizingModelsFabricTypeListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


